import { Outlet } from 'react-router-dom';

import { CommandPalette, CommandPaletteProvider } from '@/components/CommandPalette';
import { MainSidebar } from '@/components/MainSidebar';
import { useGoToShortcuts } from '@/hooks/useGoToShortcuts';

export const AdminLayout = () => {
	useGoToShortcuts();

	return (
		<CommandPaletteProvider>
			<div className="flex min-h-screen bg-white text-default">
				<MainSidebar />
				<div className="flex min-w-0 flex-1 flex-col bg-white">
					<Outlet />
				</div>
			</div>
			<CommandPalette />
		</CommandPaletteProvider>
	);
};
